var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0078D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85355 8.14646C4.65829 7.9512 4.34171 7.9512 4.14645 8.14646C3.95118 8.34172 3.95118 8.6583 4.14645 8.85357L6.64645 11.3536C6.85435 11.5615 7.19589 11.546 7.38411 11.3201L12.3841 5.3201C12.5609 5.10797 12.5322 4.79268 12.3201 4.6159C12.108 4.43912 11.7927 4.46778 11.6159 4.67992L6.9664 10.2593L4.85355 8.14646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4b467681dfd2d62762fb4672d876e672.svg";
export { ForwardRef as ReactComponent };